export default __webpack_public_path__ + "static/media/title_case4.9164bace.jpg";